import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.3333 6.66669C20.1077 6.66669 18.894 6.9081 17.7616 7.37714C16.6292 7.84619 15.6004 8.53368 14.7337 9.40036C13.867 10.267 13.1795 11.2959 12.7105 12.4283C12.2414 13.5607 12 14.7743 12 16C12 17.2257 12.2414 18.4394 12.7105 19.5717C13.1795 20.7041 13.867 21.733 14.7337 22.5997C15.6004 23.4664 16.6292 24.1539 17.7616 24.6229C18.894 25.0919 20.1077 25.3334 21.3333 25.3334C22.559 25.3334 23.7727 25.0919 24.905 24.6229C26.0374 24.1539 27.0663 23.4664 27.933 22.5997C28.7997 21.733 29.4872 20.7041 29.9562 19.5717C30.4253 18.4394 30.6667 17.2257 30.6667 16C30.6667 14.7743 30.4253 13.5607 29.9562 12.4283C29.4872 11.2959 28.7997 10.267 27.933 9.40036C27.0663 8.53368 26.0374 7.84619 24.905 7.37714C23.7727 6.9081 22.559 6.66669 21.3333 6.66669Z",
  fill: "#FF9800"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.6666 6.66669C9.44091 6.66669 8.22725 6.9081 7.09487 7.37714C5.9625 7.84619 4.9336 8.53368 4.06692 9.40036C3.20024 10.267 2.51275 11.2959 2.04371 12.4283C1.57467 13.5607 1.33325 14.7743 1.33325 16C1.33325 17.2257 1.57467 18.4394 2.04371 19.5717C2.51275 20.7041 3.20024 21.733 4.06692 22.5997C4.9336 23.4664 5.9625 24.1539 7.09487 24.6229C8.22725 25.0919 9.44091 25.3334 10.6666 25.3334C11.8923 25.3334 13.1059 25.0919 14.2383 24.6229C15.3707 24.1539 16.3996 23.4664 17.2662 22.5997C18.1329 21.733 18.8204 20.7041 19.2895 19.5717C19.7585 18.4394 19.9999 17.2257 19.9999 16C19.9999 14.7743 19.7585 13.5607 19.2895 12.4283C18.8204 11.2959 18.1329 10.267 17.2662 9.40036C16.3996 8.53368 15.3707 7.84619 14.2383 7.37714C13.1059 6.9081 11.8923 6.66669 10.6666 6.66669Z",
  fill: "#D50000"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16C12 19.17 13.584 21.9667 16 23.6533C18.416 21.9667 20 19.17 20 16C20 12.83 18.416 10.0333 16 8.34668C13.584 10.0333 12 12.83 12 16Z",
  fill: "#FF3D00"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'MCSymbolIcon',
  props: {
  size: {
    type: [String, Number],
    default: "32"
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_5, 8, _hoisted_1))
}
}

})